'use strict';

/**
 * Global Promo Banner — hover/focus detection.
 *
 * Dispatches a 'globalPromoBanner:hoverChange' CustomEvent on the banner
 * element whenever the mouse enters/leaves or keyboard focus moves in/out.
 * The auto-rotate carousel listens for this event to pause/resume autoplay.
 */

/**
 * Dispatches hover state to carousel listeners.
 * @param {HTMLElement} banner - Promo banner root element.
 * @param {boolean} isMouseHovered - Whether the pointer is over the banner.
 * @param {boolean} isFocusWithin - Whether focus is inside the banner.
 * @private
 */
function _dispatchHoverChange(banner, isMouseHovered, isFocusWithin) {
    let isHovered = isMouseHovered || isFocusWithin;

    banner.dispatchEvent(
        new CustomEvent('globalPromoBanner:hoverChange', {
            detail: { isHovered: isHovered },
            bubbles: false,
        }),
    );
}

/**
 * Initializes global promo banner hover and focus tracking.
 */
export function initGlobalPromoBanner() {
    let banner = document.getElementById('globalPromoBanner');

    if (!banner) return;

    let isMouseHovered = false;
    let isFocusWithin = false;

    banner.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') {
            isMouseHovered = true;
            _dispatchHoverChange(banner, isMouseHovered, isFocusWithin);
        }
    });

    banner.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') {
            isMouseHovered = false;
            _dispatchHoverChange(banner, isMouseHovered, isFocusWithin);
        }
    });

    banner.addEventListener('focusin', () => {
        isFocusWithin = true;
        _dispatchHoverChange(banner, isMouseHovered, isFocusWithin);
    });

    banner.addEventListener('focusout', (e) => {
        if (!banner.contains(e.relatedTarget)) {
            isFocusWithin = false;
            _dispatchHoverChange(banner, isMouseHovered, isFocusWithin);
        }
    });
}
